import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import {
  cancelOwnershipTransfer,
  getWorkspaceSettings,
  requestOwnershipTransfer,
  requestWorkspaceDeletion,
  updateWorkspaceSettings,
} from '@/services/api/workspace-settings.service'

import { useWorkspace } from './useWorkspace'

export function useWorkspaceSettings() {
  const { currentWorkspaceId } = useWorkspace()
  const queryClient = useQueryClient()
  const key = ['workspace', currentWorkspaceId, 'settings']
  const refresh = () => queryClient.invalidateQueries({ queryKey: key })

  const query = useQuery({
    queryKey: key,
    queryFn: getWorkspaceSettings,
    enabled: !!currentWorkspaceId,
    staleTime: 60 * 1000,
  })
  const update = useMutation({
    mutationFn: updateWorkspaceSettings,
    onSuccess: () => {
      void refresh()
      // The sidebar's workspace name comes from the workspace list.
      void queryClient.invalidateQueries({ queryKey: ['workspaces'] })
    },
  })
  const requestTransfer = useMutation({ mutationFn: requestOwnershipTransfer, onSuccess: refresh })
  const cancelTransfer = useMutation({ mutationFn: cancelOwnershipTransfer, onSuccess: refresh })
  const requestDeletion = useMutation({ mutationFn: requestWorkspaceDeletion })

  return {
    settings: query.data,
    isLoading: query.isLoading,
    update: update.mutateAsync,
    isUpdating: update.isPending,
    requestTransfer: requestTransfer.mutateAsync,
    isRequestingTransfer: requestTransfer.isPending,
    cancelTransfer: cancelTransfer.mutateAsync,
    requestDeletion: requestDeletion.mutateAsync,
    isRequestingDeletion: requestDeletion.isPending,
  }
}
